var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "251.75px",
    height: "251.75px",
    viewBox: "0 -9.52 251.75 251.75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc742;}.cls-2,.cls-8{fill:#fff;}.cls-3{fill:#275563;}.cls-4{fill:#f7ead0;}.cls-4,.cls-9{opacity:0.5;}.cls-5{fill:#908152;}.cls-6{fill:#efa536;}.cls-7,.cls-8{opacity:0.7;}.cls-10,.cls-9{fill:#d9f0ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.81,136l90.6,90.6a9.56,9.56,0,0,0,13.52,0l2-2,47.79-47.79,28-28,12-12c5.33-5.32,11.3-10.24,15.55-16.54,4.83-7.17,4.87-14.37,5.54-22.65L224.25,79l3.33-41.59,1-12.13c1-12.28-8.4-21.57-20.69-20.48l-66.44,5.92c-6.87.61-14,.4-20.64,2.39-7.73,2.3-12,7.79-17.54,13.28l-26,26L20,109.61,9.5,120.11l-2,2a9.56,9.56,0,0,0,0,13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.83,44.16c0,.35,0,.68,0,1A21,21,0,0,1,207,57.71a19.77,19.77,0,0,1-30.61,0,21,21,0,0,1-4.86-12.53c0-.33,0-.67,0-1s0-.85,0-1.27h0c.65-10.89,9.41-19.51,20.15-19.51s19.5,8.62,20.15,19.51h0Q211.83,43.53,211.83,44.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.65,66.41c-13.33,0-24.18-11.12-24.18-24.8s10.85-24.8,24.18-24.8,24.19,11.12,24.19,24.8S205,66.41,191.65,66.41Zm0-41.6c-8.92,0-16.18,7.54-16.18,16.8s7.26,16.8,16.18,16.8,16.19-7.54,16.19-16.8S200.57,24.82,191.65,24.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.02 10.44 135.17 15.31 14.31 135.99 6.3 127.98 124.02 10.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.38,36.49a4,4,0,0,1-2.83-1.17l-3.18-3.18A4,4,0,0,1,131,26.48l3.18,3.18a4,4,0,0,1-2.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.15,93.26a4,4,0,0,1-2.83-1.17l-6.55-6.55a4,4,0,1,1,5.66-5.66L191,86.43a4,4,0,0,1-2.83,6.83ZM169.23,74.34a4,4,0,0,1-2.83-1.17l-6.55-6.55A4,4,0,1,1,165.51,61l6.55,6.55a4,4,0,0,1-2.83,6.83ZM150.31,55.41a4,4,0,0,1-2.83-1.17l-6.55-6.55A4,4,0,0,1,146.58,42l6.55,6.55a4,4,0,0,1-2.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.71,108.81a4,4,0,0,1-2.83-1.17l-3.18-3.18a4,4,0,0,1,5.66-5.66l3.18,3.18a4,4,0,0,1-2.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.57,55.8c-11.57,0-22.88-5.1-33.19-9.75-1.84-.83-3.66-1.65-5.43-2.42a4,4,0,0,1,3.18-7.34c1.81.78,3.66,1.62,5.54,2.47,13.28,6,27,12.19,39.82,7.24l22.81-8.89a4,4,0,1,1,2.9,7.45l-22.82,8.89A35.19,35.19,0,0,1,213.57,55.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 75.13,
    cy: 60.01,
    rx: 45.6,
    ry: 45.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.76,148.69a4,4,0,0,1-2.83-6.83l31.71-31.73a4,4,0,1,1,5.66,5.65L80.59,147.52A4,4,0,0,1,77.76,148.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.12,162a4,4,0,0,1-2.83-6.83l52.77-52.81a4,4,0,1,1,5.66,5.65L93.95,160.86A4,4,0,0,1,91.12,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.47,175.38a4,4,0,0,1-2.83-6.83l52.77-52.81a4,4,0,1,1,5.66,5.65L107.3,174.2A4,4,0,0,1,104.47,175.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.5,104.2h0c4.73,4.74,6.11,11,3.08,14.05l-112.34,112-8.56-8.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.7,180.14a3,3,0,0,1-2.08-.84l-8.78-8.45A3,3,0,1,1,62,166.53L70.78,175a3,3,0,0,1-2.08,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.82,191.8a3,3,0,0,1-2.08-.84L74,186.39a3,3,0,0,1,4.16-4.32l4.75,4.57a3,3,0,0,1-2.08,5.16Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 50.1,
    cy: 159.18,
    r: 3.85,
    transform: "translate(-99.34 84.9) rotate(-46.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.49,232.71a13.51,13.51,0,0,1-9.59-4L4,137.81a13.58,13.58,0,0,1,0-19.18L99.75,22.85c.83-.83,1.63-1.65,2.41-2.47,4.56-4.71,9.27-9.58,16.81-11.82,5.3-1.58,10.68-1.88,15.89-2.17,1.91-.11,3.72-.21,5.53-.37L206.84.11a22.89,22.89,0,0,1,18.5,6.38,22.85,22.85,0,0,1,6.53,18.41l-5.8,72.41c-.07.84-.13,1.66-.19,2.48-.56,7.6-1.08,14.77-6,22.09-3.42,5.07-7.78,9.22-12,13.23-1.34,1.28-2.73,2.6-4,3.91l-7.92,7.92-21.23,21.23a4,4,0,0,1-5.66-5.66l21.23-21.23,7.92-7.92c1.38-1.38,2.8-2.73,4.18-4,4.08-3.88,7.94-7.55,10.88-11.9,3.75-5.56,4.15-11.14,4.67-18.2.06-.83.12-1.68.19-2.53l5.8-72.41a15,15,0,0,0-4.19-12.09,15,15,0,0,0-12.16-4.09L141.1,14c-1.94.17-3.9.28-5.8.39-5,.28-9.65.54-14.05,1.85-5.53,1.65-9.15,5.39-13.34,9.72-.82.85-1.65,1.7-2.51,2.56L9.62,124.29a5.57,5.57,0,0,0,0,7.86l.34.34,90.6,90.6a5.57,5.57,0,0,0,7.87,0l2-2c5.31-5.31,9.41-9.15,13.38-12.87s8-7.48,13.19-12.69a4,4,0,0,1,5.66,5.66c-5.31,5.31-9.41,9.15-13.38,12.87s-8,7.48-13.19,12.69l-2,2A13.52,13.52,0,0,1,104.49,232.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 67.79,
    cy: 52.44,
    r: 45.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M113.25,51.12a45.68,45.68,0,1,1-89-14.51c3.75,21.1,23.17,40.1,43.32,40.1s38.54-15.27,43.32-40.1A45.43,45.43,0,0,1,113.25,51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112.85,50.42a45.68,45.68,0,1,1-91.35,0,46.21,46.21,0,0,1,.39-6,45.68,45.68,0,0,0,90.58,0A46.25,46.25,0,0,1,112.85,50.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.22,47.13V39.8q0-3.61,2-5.3a8.34,8.34,0,0,1,5.48-1.68,8.46,8.46,0,0,1,5.5,1.67q2.07,1.68,2.07,5.29v7.33q0,3.62-2.06,5.3a8.46,8.46,0,0,1-5.49,1.68,8.34,8.34,0,0,1-5.49-1.67Q48.22,50.74,48.22,47.13Zm5,0q0,2.48,2.56,2.48t2.6-2.48V39.78q0-2.48-2.61-2.48a2.23,2.23,0,0,0-2.55,2.48ZM55.92,70.2a2.23,2.23,0,0,1,.25-1L73.93,32a2.16,2.16,0,0,1,2.13-1.29,3.25,3.25,0,0,1,2.09.77,2.42,2.42,0,0,1,1,2,2.21,2.21,0,0,1-.2,1L61.1,71.64a2.29,2.29,0,0,1-2.28,1.29,2.77,2.77,0,0,1-2.07-.85A2.65,2.65,0,0,1,55.92,70.2Zm15.66-6.47V56.4q0-3.61,2-5.3a8.34,8.34,0,0,1,5.48-1.68,8.46,8.46,0,0,1,5.5,1.67q2.07,1.68,2.07,5.29v7.33q0,3.62-2.06,5.3a8.46,8.46,0,0,1-5.5,1.68A8.34,8.34,0,0,1,73.61,69Q71.58,67.35,71.58,63.73Zm5,0A2.23,2.23,0,0,0,79.1,66.2q2.61,0,2.6-2.48V56.38q0-2.48-2.61-2.48t-2.55,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.34,100.32A49.68,49.68,0,1,1,117,50.65,49.73,49.73,0,0,1,67.34,100.32ZM67.34,9A41.68,41.68,0,1,0,109,50.65,41.72,41.72,0,0,0,67.34,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.84,192.51a4,4,0,0,1-2.86-6.79l5.1-5.23a4,4,0,1,1,5.73,5.58l-5.1,5.23A4,4,0,0,1,149.84,192.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.8,178.19a4,4,0,0,1-2.87-6.79l.21-.22a4,4,0,0,1,5.73,5.58l-.21.22A4,4,0,0,1,163.8,178.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/Offer.47fc9462665f6fc80b8fcae97d2d59c0.svg";
export { ForwardRef as ReactComponent };